var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/array-slice.js
// module id = 2199
// module chunks = 0